/**
 * Utilitários compartilhados da vitrine de cursos.
 */

export function truncarDescricao(texto, limite = 150) {
    if (!texto) return '';

    const descricao = String(texto).trim();
    if (descricao.length <= limite) return descricao;

    const trecho = descricao.slice(0, limite + 1);
    const ultimoEspaco = trecho.lastIndexOf(' ');
    const textoCortado = ultimoEspaco > 0 ? trecho.slice(0, ultimoEspaco) : trecho.slice(0, limite);

    return `${textoCortado.trimEnd()}...`;
}

export function normalizarTextoBusca(...partes) {
    return partes
        .filter(Boolean)
        .join(' ')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
}

export function categoriaCursoLabel(curso) {
    const texto = normalizarTextoBusca(
        curso?.titulo,
        curso?.descricao,
        curso?.target_audience,
        curso?.nivel
    );

    if (texto.includes('enem')) return 'ENEM';
    if (texto.includes('simulado')) return 'SIMULADOS';
    if (texto.includes('video')) return 'VÍDEOAULAS';
    if (texto.includes('redacao')) return 'REDAÇÃO';
    if (curso?.target_audience) return String(curso.target_audience).toUpperCase();
    return 'CURSO';
}

export function statusProgressoLabel(progresso) {
    const valor = Number(progresso) || 0;
    if (valor >= 100) return 'Concluído';
    if (valor > 0) return 'Em andamento';
    return 'Não iniciado';
}
